<template>
    <div class="submission-items">

        <div v-for="submission in getFilteredSubmissions" :key="submission.id" class="c-card">
            <div class="c-card__liner c-card__liner--green">
                
                <div class="c-card__content">	
                    <div class="c-card__icon">
                        <svg width="31" height="39" viewBox="0 0 31 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M9.03898 10.75H21.9618M9.03898 17.3125H21.9618M9.03898 23.875H15.5004M5.80777 2H25.1924C27.5715 2 29.5 3.95881 29.5 6.37508L29.4995 32.6251C29.4995 35.0413 27.5709 37 25.1919 37L5.80759 36.9999C3.42856 36.9999 1.49998 35.0411 1.5 32.6249L1.50017 6.37498C1.50018 3.95874 3.42876 2 5.80777 2Z" />
                        </svg>
                    </div>
                            
                    <div class="c-card__details">
                        <h3 class="c-card__title c-card__title--includes-extension">
                            <a :href="submission.filelink" target="_blank">
                                {{ submission.title }}
                            </a>
                            <span class="c-card__file-extension">
                                <span class="c-card__file-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
                                        <path d="M6 30.6725C6.60706 31.2653 7.43041 31.5984 8.28892 31.5984H27.7111C28.5696 31.5984 29.3929 31.2653 30 30.6725M18.0018 4.59839V22.5121M18.0018 22.5121L25.4007 15.6673M18.0018 22.5121L10.6029 15.6673" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                {{ submission.extension }} 
                                <span class="c-card__filesize">({{ submission.filesize }})</span>
                            </span>								
                        </h3>
                        
                        <div class="c-card__description u-content">{{ submission.description }}</div>

                        <div class="c-card__date">{{ submission.date }}</div>

                        <div v-if="submission.tags" class="c-card__categories">
                            <a v-for="tag in submission.tags" :href="tag.value" class="c-card__tag c-card__tag--white">{{ tag.label }}</a>
                        </div>

                    </div>
                </div>

            </div>				
        </div>

        <pagination></pagination>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import Pagination from "./SubmissionsPagination.vue";

export default {
    name: "SubmissionCards",
    components: {
        Pagination,
    },
    computed: {
        ...mapFields([
            "viewContent.submissions",
            "currentPage",
            "perPage",
            "totalPages",
        ]),
        ...mapGetters([
            "getFilteredSubmissions",
        ]),
    }
}
</script>